import { MenuItem } from './menu.model';

export const DESIGNER_MENU: MenuItem[] = [
    // {
    //     id: 1,
    //     label: 'MENUITEMS.MENU.TEXT',
    //     isTitle: true
    // },
    // {
    //     id: 2,
    //     label: 'MENUITEMS.DASHBOARDS.TEXT',
    //     icon: 'uil-home-alt',
    //     link: '/',
    // },
    {
        id: 9,
        label: 'Orders',
        icon: 'uil-bolt-alt',
        subItems: [
            // {
            //     id: 80,
            //     label: 'View Orders',
            //     link: '/orders/view-orders',
            //     parentId: 3
            // },
            {
                id: 81,
                label: 'View Orders By Po',
                link: '/orders/view-orders-by-po',
                parentId: 4
            },
            // {
            //     id:82,
            //     label: 'View Reports',
            //     link: '/orders/reports',
            //     parentId: 5                
            // },
            // {
            //     id:82,
            //     label: 'Invoice',
            //     link: '/orders/add-invoice',
            //     parentId: 5                
            // }
        ]
    },
];

